export const normalizeEntityId = (value) => {
  const parsed = Number(value);
  return Number.isInteger(parsed) && parsed > 0 ? parsed : null;
};

export const getBookingDetailPath = (bookingOrId) => {
  if (bookingOrId == null) return null;
  const id = typeof bookingOrId === 'object'
    ? normalizeEntityId(bookingOrId.id ?? bookingOrId.booking_id)
    : normalizeEntityId(bookingOrId);
  return id ? `/booking/detail/${id}/` : null;
};

export const getCustomerDetailPath = (guestOrId) => {
  if (guestOrId == null) return null;
  const id = typeof guestOrId === 'object'
    ? normalizeEntityId(guestOrId.id ?? guestOrId.guest_id)
    : normalizeEntityId(guestOrId);
  return id ? `/customerhub/customers/${id}/` : null;
};

export const resolvePrimaryGuestId = (booking, guest) => {
  return normalizeEntityId(
    guest?.id
    ?? guest?.guest_id
    ?? booking?.guest_id
    ?? booking?.guest?.id,
  );
};

const buildGuestDisplayName = (booking, guest) => {
  if (booking?.guest_name) return booking.guest_name;
  if (guest?.name) return guest.name;
  const parts = [
    guest?.title,
    guest?.first_name,
    guest?.middle_name,
    guest?.last_name,
  ].filter(Boolean);
  return parts.join(' ').trim();
};

/** Normalize booking payloads from drawer APIs so guest links always resolve. */
export const enrichBookingGuestRef = (booking) => {
  if (!booking || typeof booking !== 'object') return booking;

  const guest = booking.guest && typeof booking.guest === 'object' ? booking.guest : null;
  const guestId = normalizeEntityId(booking.guest_id ?? guest?.id);
  const guestPhone = booking.guest_phone || booking.phone || guest?.phone || '';
  const guestName = buildGuestDisplayName(booking, guest);

  return {
    ...booking,
    guest_id: guestId,
    guest: guestId ? (guest || { id: guestId }) : guest,
    guest_name: guestName || booking.guest_name || '',
    guest_phone: guestPhone,
    phone: booking.phone || guestPhone,
  };
};
